import type { FC, ReactNode } from 'react'

import { CartSidebarLayout } from 'components/layout/CartSidebarLayout'
import styled from 'styled-components'

const StyledContentLayoutContainer = styled.div`
  align-items: center;
  background-color: ${({ theme }) => theme.color.lightestGrey100};
  display: flex;
  flex-direction: column;
  width: 100%;
`

interface ContentPageLayoutProps {
  'data-test-id'?: string
  children?: ReactNode
  className?: string
  hideGlobalNavigation?: boolean
  showFooter?: boolean
}

const _ContentPageLayout: FC<ContentPageLayoutProps> = ({
  children,
  hideGlobalNavigation,
  showFooter,
  'data-test-id': dataTestId,
}) => {
  return (
    <CartSidebarLayout
      hideMainNavigation={hideGlobalNavigation}
      showFooter={showFooter}
      data-test-id={dataTestId}
    >
      <StyledContentLayoutContainer className="contentLayoutContainer">
        {children}
      </StyledContentLayoutContainer>
    </CartSidebarLayout>
  )
}

export const ContentPageLayout = styled(_ContentPageLayout)({})
